/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const preferredPaymentMethodSchema = z.enum(['stripe', 'invoice'])

export type PreferredPaymentMethodSchema = z.infer<typeof preferredPaymentMethodSchema>
